import React, { Component } from 'react';
import './analytics.css';
import $ from 'jquery';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRange } from 'react-date-range';
import moment from 'moment';
import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

class Analytics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateSelection: [{
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection'
            }],
            totalAccess: 0,
            totalPeakAccess: 0,
            barChart: []
        };
    }

    componentDidMount = () => {
        this.getConnectionsStats("lastMonth")
    }

    getConnectionsStats = (type, dateSelection) => {
        let url = '/api/v1/connection/statistics?type=' + type;
        if (!type) url = '/api/v1/connection/statistics?startDate=' + dateSelection.startDate + '&endDate=' + dateSelection.endDate;
        $.ajax({
            method: 'GET',
            url: url,
            success: (success) => {
                this.setSelectionDate(type);
                this.setState({
                    barChart: success.response.accessList,
                    totalAccess: success.response.totalAccess
                })
            },
            error: (err) => {
                this.props.notifyError(err.responseJSON.message);
            }
        });
    }


    setSelectionDate = (type) => {
        let startDate, endDate;
        switch (type) {
            case "lastWeek":
                [startDate, endDate] = this.getLastWeekRange();
                break;
            case "thisWeek":
                [startDate, endDate] = this.getThisWeekRange();
                break;
            case "lastMonth":
                [startDate, endDate] = this.getLastMonthRange();
                break;
            case "thisMonth":
                [startDate, endDate] = this.getThisMonthRange();
                break;
            default: return;
        }
        this.setState({
            dateSelection: [{
                startDate: new Date(startDate),
                endDate: new Date(endDate),
                key: 'selection'
            }]
        })
    }


    getLastMonthRange = () => {
        let startDate = moment().subtract(1, 'month').startOf('month').format("YYYY-MM-DDT00:00:00.000");
        let endDate = moment().subtract(1, 'month').endOf('month').format("YYYY-MM-DDT00:00:00.000");
        return [startDate, endDate];
    }

    getThisMonthRange = () => {
        let startDate = moment().startOf('month').format("YYYY-MM-DDT00:00:00.000");
        let endDate = moment().format("YYYY-MM-DDT00:00:00.000");
        return [startDate, endDate];
    }

    getThisWeekRange = () => {
        let startDate = moment().startOf('week').format("YYYY-MM-DDT00:00:00.000");
        let endDate = moment().format("YYYY-MM-DDT00:00:00.000");
        return [startDate, endDate];
    }

    getLastWeekRange = () => {
        let startDate = moment().subtract(1, 'weeks').startOf('week').format("YYYY-MM-DDT00:00:00.000");
        let endDate = moment().subtract(1, 'weeks').endOf('week').format("YYYY-MM-DDT00:00:00.000");
        return [startDate, endDate];
    }

    formatXAxis = (tickItem) => {
        // If using moment.js
        return moment(tickItem).format('MMM Do YY')
    }

    handleSelect = (ranges) => {
        this.setState({
            dateSelection: [ranges.selection]
        })
        this.getConnectionsStats(false, ranges.selection);
    }


    render() {
        return (<div className="container-fluid m-1">
            <h3>Conexões</h3>
            <hr />
            <div className="back-ground">
                <div className="row">
                    <div className="col-sm-4">
                        <div className="nav-tabs-outer">
                            <button type="button" className="stats-btn btn btn-secondary" onClick={() => { this.getConnectionsStats('thisWeek') }}>This Week</button>
                            <button type="button" className="stats-btn btn btn-secondary" onClick={() => { this.getConnectionsStats('lastWeek') }}>Last Week</button>
                            <button type="button" className="stats-btn btn btn-secondary" onClick={() => { this.getConnectionsStats('thisMonth') }}>This Month</button>
                            <button type="button" className="stats-btn btn btn-secondary" onClick={() => { this.getConnectionsStats('lastMonth') }}>Last Month</button>
                        </div>
                    </div>
                    <div className="col-sm-8">
                        <div className="tab-content">
                            <span className="txt"> Conexões</span>
                            <br />
                            <hr className="line-conn"></hr>
                            <span className="col-sm-5"> Acessos único </span>
                            <span className="line"> {this.state.totalAccess} </span>
                            <hr className="line-conn"></hr>
                            <span className="col-sm-5"> Pico de acesso </span>
                            <span className="line"> {this.state.totalPeakAccess} </span>
                            <hr className="line-conn"></hr>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4">
                        <DateRange
                            className="calendar"
                            showDateDisplay={false}
                            editableDateInputs={true}
                            onChange={this.handleSelect}
                            moveRangeOnFirstSelection={false}
                            ranges={this.state.dateSelection}
                            rangeColors={["#3ea497"]}

                        />
                    </div>
                    <div className="col-sm-8">
                        <div className="tab-content">
                            <br />
                            <br />
                            <div>
                                <BarChart
                                    width={850}
                                    height={400}
                                    data={this.state.barChart}
                                    margin={{
                                        top: 5, right: 30, left: 20, bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="5 5" />
                                    <XAxis dataKey="dateTime" tickFormatter={this.formatXAxis} />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="connections" name="Conexões" fill="#3ea497" />
                                </BarChart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}
export default Analytics;


// WEBPACK FOOTER //
// ./src/components/DashboardPage/ConnectionsAnalytics/analytics.js